import request from '@/utils/request';
import Resource from '@/api/resource';

class RoleResource extends Resource {
  constructor() {
    super('roles');
  }

  permissions(id) {
    return request({
      url: '/' + this.uri + '/' + id + '/permissions',
      method: 'get',
    });
  }

  /** 获取角色列表 */
  getRoleList() {
    return request({
      url: `/${this.uri}`,
      method: 'get',
    });
  }

  /** 新增角色 */
  addRole(data) {
    return request({
      url: `/${this.uri}`,
      method: 'post',
      data,
    });
  }
}

export { RoleResource as default };
